<div class="page">
    <div class="page-content content" *ngFor="let part of parts;">
        <h1>{{'layout.Terms_of_use'|translate}}</h1>
        <div class="section-webpage-part" *ngFor="let question of part;index as i;">
            <h2 *ngIf="i !== 0"
                [innerHTML]="question.rank.substr(1) + ' ' + translationService.getTranslatedAttribute('title', question.translations, locale)">{{question.rank}}</h2>
            <p [innerHTML]="translationService.getTranslatedAttribute('text', question.translations, locale) | safeHtml"></p>
        </div>
    </div>
</div>